import React from 'react';
import { Select } from '../../components/ui-kit';

const DefaultSingleSelector = props => {
  const options = () => {
    const styleFunction = props.styleFunction || (() => ({}));
    return props.objects.map(object => {
      const textLabel = object.name;
      const label = (
        <div style={{ maxHeight: '40px', overflow: 'hidden', whiteSpace: 'nowrap' }}>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <span style={styleFunction(object) || {}}>{textLabel}</span>
          </div>
        </div>
      );
      return { value: object.id, textLabel, label };
    });
  };

  const selectedOptions = () => options().filter(o => props.selectedIds.includes(o.value));

  const filterOption = (op, filterValue) => op.data.textLabel.toLowerCase().includes(filterValue.toLowerCase());

  const handleChange = events => {
    if (!Array.isArray(events)) events = [events].filter(Boolean);
    const ids = events.map(e => e.value);
    props.handleChange(ids);
  };

  return (
    <Select
      value={selectedOptions()}
      onChange={handleChange}
      options={options()}
      isMulti={false}
      isClearable={false}
      isSearchable={true}
      className="react-select"
      placeholder={I18n.t('none')}
      filterOption={filterOption}
    />
  );
};

export default DefaultSingleSelector;
